// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2tN-h","actionsCol":"EnrolledClinics_actionsCol__3lWMk"};